// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__KqFkd"};